/**
 * 风格卡片节点：带封面的提示词片段容器。
 *
 * 节点主体以封面图为主视觉，底部叠半透明渐变 + 风格名称 + 分类标签。
 * 输出为 data.prompt，下游生图/生视频节点聚合上游文本时自动包含（与 text/llm 同口径）。
 * 不可编辑内容——换风格 = 删旧建新。
 */
import { Palette } from 'lucide-react';
import type { CanvasNode, StyleCardNodeData } from '../types';
import { NodeWrapper } from './NodeWrapper';
import { resolveBrowserMediaUrl } from '../../../utils/storageUrl';

interface StyleCardNodeProps {
  node: CanvasNode<StyleCardNodeData>;
  selected: boolean;
  highlighted: boolean;
}

export function StyleCardNode({ node, selected, highlighted }: StyleCardNodeProps) {
  const data = node.data;
  const coverSrc = resolveBrowserMediaUrl(data.coverUrl) || data.coverUrl;

  return (
    <NodeWrapper node={node} selected={selected} highlighted={highlighted} stretchContent>
      <div className="relative h-full w-full overflow-hidden rounded-lg">
        {coverSrc ? (
          <img
            src={coverSrc}
            alt={data.name}
            className="h-full w-full object-cover"
            draggable={false}
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-purple-100 to-violet-200">
            <Palette className="h-8 w-8 text-purple-300" />
          </div>
        )}
        {/* 底部渐变叠层 + 信息 */}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent px-2.5 py-2 pt-8">
          <div className="flex items-center gap-1.5">
            <span className="truncate text-sm font-medium text-white">{data.name}</span>
          </div>
          {data.category && (
            <span className="mt-0.5 inline-block rounded bg-white/20 px-1.5 py-0.5 text-[10px] text-white/80">
              {data.category}
            </span>
          )}
        </div>
      </div>
    </NodeWrapper>
  );
}
